/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { TermStatus } from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/lib/academicTermTypes';
import type { DegreePlan_TermPlanFragment as TermPlan } from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/learnerPlanFragment';
import { getPlannedSegCoursesFromTermPlan } from 'bundles/degree-home/components/v3-dpm/lib/termsUtils';

import { getCreditSummaryForCourses } from '../../lib/gradeUtils';
import AcademicTermsCard from './AcademicTermsCard';

type Props = {
  pastTermPlans: TermPlan[];
};

const PastTerms = ({ pastTermPlans }: Props) => {
  return (
    <React.Fragment>
      {pastTermPlans.map((term) => {
        const plannedCourses = getPlannedSegCoursesFromTermPlan(term);
        const creditSummary = getCreditSummaryForCourses(plannedCourses);
        return (
          <AcademicTermsCard
            key={term.estimatedTermId}
            explicitTermId={term.linkedTerm?.id}
            termName={term.estimatedTermName}
            courses={plannedCourses}
            termStatus={TermStatus.COMPLETE}
            creditSummary={creditSummary}
            isTermPlanAutoCorrected={term.autoCorrected}
          />
        );
      })}
    </React.Fragment>
  );
};

export default PastTerms;
